<!-- Login screen - only shown when not authenticated AND not processing -->
<app-main-sign-in *ngIf="!userAuthInfoReference?.token && !isProcessingAuth"></app-main-sign-in>

<!-- Show "Signing in..." banner during auth processing -->
<!-- FIN-0108: Dark mode uses base and elevated surfaces -->
<div *ngIf="isProcessingAuth" class="fixed top-0 left-0 w-full h-screen bg-white dark:bg-dark-base z-50 flex items-start">
  <!-- Banner matching the Connecting... style -->
  <div class="w-full px-4 py-2 bg-gray-50 dark:bg-dark-elevated border-b border-gray-200 dark:border-dark-border flex items-center justify-center">
    <div class="text-gray-400 dark:text-dark-text-tertiary text-sm font-light">Signing in...</div>
  </div>
</div>

<!-- Main app when authenticated - use router-outlet for Labs navigation -->
<router-outlet *ngIf="userAuthInfoReference?.token"></router-outlet>
